import DivotDepth from './DivotDepth';

export default DivotDepth;
